module.exports = __webpack_public_path__ + "img/jyx.94b53c78.png";